import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const bulkSubmitDraftsForReview = api(async function bulkSubmitDraftsForReview({ projectId, scheduleIds }) {
    return mutate(
        gql`
            mutation BulkSubmitDraftsForReview($projectId: String!, $scheduleIds: [String!]!) {
                bulkSubmitDraftsForReview(projectId: $projectId, scheduleIds: $scheduleIds) {
                    submitted {
                        scheduleId
                        title
                        code
                    }
                    failed {
                        scheduleId
                        title
                        code
                        reason
                    }
                    skipped {
                        scheduleId
                        title
                        code
                        reason
                    }
                }
            }
        `,
        { projectId, scheduleIds },
        { returns: "bulkSubmitDraftsForReview" }
    )
})
